import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { App as AntdApp, ConfigProvider } from "antd";
import App from "./App";
import { queryClient } from "./queryClient";
import { antThemeConfig, getAntLocale } from "./theme/antTheme";
import { ErrorBoundary } from "./components/layout";
import { LoginProvider } from "./contextApi/LoginContext";
import i18n from "./translationService";
import { getDistributorBasename } from "./util/distributorBranding.service";
import "./styles/index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <AntdApp>
        <QueryClientProvider client={queryClient}>
          <I18nextProvider i18n={i18n}>
            <ConfigProvider theme={antThemeConfig} locale={getAntLocale(i18n.language ?? "en")}>
              <LoginProvider>
                <BrowserRouter basename={getDistributorBasename()}>
                  <App />
                </BrowserRouter>
              </LoginProvider>
            </ConfigProvider>
          </I18nextProvider>
          {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
      </AntdApp>
    </ErrorBoundary>
  </React.StrictMode>
);
